import axios from 'axios';
import { SellerGroup } from './types';

type FetchResponse = {
  success: boolean;
  data: {
    success: boolean;
    columns: string[];
    data: (string | null)[][];
  };
};

export async function fetchSellerGroups(): Promise<SellerGroup[]> {
  const { data } = await axios.get<FetchResponse>('/seller-group');
  const rows = data?.data?.data ?? [];
  return rows.map((row) => ({
    id: String(row[0] ?? ''),
    name: String(row[1] ?? ''),
    profile: row[2] ?? '',
  }));
}

type UpdateResponse = {
  success: boolean;
  error?: string;
};

export async function updateSellerGroupProfile(
  grupoId: string,
  profile: string
): Promise<UpdateResponse> {
  const { data } = await axios.post<UpdateResponse>(
    `/seller-group/${grupoId}`,
    { profile }
  );
  return data;
}
